import React, { useEffect } from "react";
import { Route, Routes,  useLocation, useNavigate } from "react-router-dom";
import Home from "./Home";

import AboutMe from "./AboutMe";
import ProjectComponent from "./ProjectComponent";
import Skills from "./Skills";
import AllProjects from "./AllProjects";
import ExperienceComponent from "./ExperienceComponent";
import AllExperiences from "./AllExperiences";
import WebChess from "./WebChess";
import ScamSlam from "./ScamSlam";

function RouterApp() {
  const location = useLocation();

    useEffect(() => {
      // Check if the page is visited from the hash route #/WebChessPlay
      if (window.location.hash === "#/WebChessPlay") {
        const reloadedFlag = sessionStorage.getItem("reloaded-WebChessPlay");

        if (!reloadedFlag) {
          // Set flag so it doesn't reload on future visits
          sessionStorage.setItem("reloaded-WebChessPlay", "true");
          // Reload the page
          window.location.reload();
        }
      }
      return () => {
            if (location.pathname !== "/WebChessPlay") {
              sessionStorage.removeItem("reloaded-WebChessPlay"); // Reset the flag when leaving WebChessPlay
            }
          };
    }, [location]); // Trigger useEffect on location change (i.e., navigation)




  let projects = require("./Resources/projects");
  let experiences = require("./Resources/experiences");

  return (
    <div className="RouterApp" style={{ marginLeft: "5%", marginRight: "5%", marginTop: "2%", marginBottom: "5%", height: "81%" }}>
      <Routes>
        {/* Base routes */}
        <Route key="home" path="/" element={<Home />} />
        <Route key="aboutme" path="/AboutMe" element={<AboutMe />} />

        {/* Dynamic project routes */}
        {projects.projects.map((item) => (
          <Route key={`project-${item.link}`} path={`/${item.link}`} element={<ProjectComponent link={item.link} />} />
        ))}

        <Route key="skills" path="/Skills" element={<Skills />} />
        <Route key="allprojects" path="/Projects" element={<AllProjects />} />
        <Route key="allexperiences" path="/Experiences" element={<AllExperiences />} />
        <Route key="webchess" path="/WebChessPlay" element={<WebChess />} />
        <Route key="scamslam" path="/ScamSlamPlay" element={<ScamSlam />} />

        {/* Dynamic experience routes */}
        {experiences.experiences.map((item) => (
          <Route key={`experience-${item.link}`} path={`/${item.link}`} element={<ExperienceComponent link={item.link} />} />
        ))}
      </Routes>
    </div>
  );
}

export default RouterApp;
